function PackagesPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Packages Page</h1>
        <p className="text-gray-600">
          Package listing and management coming soon...
        </p>
      </div>
    </div>
  );
}

export default PackagesPage;
